import type { LucideIcon } from 'lucide-react'
import { Plus } from 'lucide-react'

interface QuickCreateIconProps {
  icon: LucideIcon
}

export function QuickCreateIcon({ icon: Icon }: QuickCreateIconProps) {
  return (
    <span className="relative inline-flex">
      <Icon className="size-5" aria-hidden="true" />
      <span
        aria-hidden="true"
        className="bg-primary text-primary-foreground ring-background absolute -right-1.5 -bottom-1.5 flex size-3.5 items-center justify-center rounded-full ring-2"
      >
        <Plus className="size-2.5" strokeWidth={3} />
      </span>
    </span>
  )
}
